<template>
  <div>
    <div class="mb-12 to-hide">
      <div class="d-flex justify-space-between align-center mb-3">
        <Button theme="8" @click.native="print()" v-if="$route.query.preview">
          Export PDF
        </Button>
      </div>
      <divcard class="d-flex justify-space-between mb-2" style="gap: 24px">
        <div class="d-flex" style="gap: 24px">
          <div>
            <v-img
              :src="require('../../assets/mhesr.png')"
              min-width="100"
              max-width="100"
              aspect-ratio="1"
            ></v-img>
          </div>

          <div>
            <div class="page-title">
              สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม
              (สป.อว.)

              <!-- For Dev -->
              <Button
                v-if="currentStep == 2 || currentStep == 3 || currentStep == 4"
                theme="4"
                min-width="120px"
                :disabled="isLoading"
                @onClick="autoField(currentStep, plan_code)"
              >
                autoField - step {{ currentStep }} - {{ plan_code }}
              </Button>
              <!-- /*For Dev -->
            </div>
            <div class="d-flex" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="jam:clock"
                color="var(--theme-color-nine)"
              ></Iconify>
              <div>
                วันที่เปิดรับโครงการ
                {{
                  masterData.form_b?.plan?.main_project ?
                  toDateRangeFormat(
                    masterData.form_b?.plan?.main_project?.start_date,
                    masterData.form_b?.plan?.main_project?.end_date
                  )
                  :
                  toDateRangeFormat(
                    masterData?.main_project?.start_date,
                    masterData?.main_project?.end_date
                  )
                }}
              </div>
            </div>

            <div class="d-flex" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="jam:clock"
                color="var(--theme-color-nine)"
              ></Iconify>
              <div>
                <div>
                  วันที่พิจารณาโครงการ
                  {{
                    toDateFormat(
                      masterData.form_b?.plan?.main_project?.consider_date ?
                        masterData.form_b?.plan?.main_project?.consider_date :
                        masterData?.main_project?.consider_date
                    )
                  }}
                </div>
                <div>
                  {{ masterData.form_b?.plan?.main_project?.name ? 
                    masterData.form_b?.plan?.main_project?.name : 
                    masterData?.main_project?.name  
                  }}
                </div>
              </div>
            </div>

            <!-- <div class="d-flex align-center" style="gap: 18px">
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="ion:document-text"
                color="var(--theme-color-nine)"
              ></Iconify>
              <div>
                <div class="container-form-title">
                  แบบฟอร์ม B
                </div>
              </div>
            </div> -->

            <div
              v-if="docTypeName()"
              class="d-flex align-center"
              style="gap: 18px"
            >
              <Iconify
                class="left-side d-flex justify-end"
                size="15px"
                icon="ion:mail-unread"
              ></Iconify>
              <span>{{ docTypeName() }}</span>
            </div>
          </div>
        </div>

        <div class="d-flex" style="gap: 18px">
          <div class="form-tag">
            <div>แบบฟอร์ม</div>
            <div>B</div>
          </div>

          <div class="budget-tag">
            <div>ปี งปม.</div>
            <div>
              {{  masterData.form_b?.fiscal_year ?
                  masterData.form_b?.fiscal_year : 
                  masterData.main_project?.fiscal_year
              }}
            </div>
          </div>
        </div>
      </divcard>

      <StatusStep
        v-if="!$route.query.preview"
        :current-step="currentStep"
        :steps="documentSteps"
        @onClick="jumpStep"
      ></StatusStep>
    </div>

    <!--  Form switcher  -->
    <div>
      <BFormGeneral
        v-if="currentStep === 1 && !$route.query.preview"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f1_formKey"
      ></BFormGeneral>
      <BFormProject
        v-if="currentStep === 2"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f2_formKey"
      ></BFormProject>
      <BFormPlan
        v-if="currentStep === 3"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f3_formKey"
      ></BFormPlan>
      <BFormOOI
        v-if="currentStep === 4"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f4_formKey"
      ></BFormOOI>
      <BFormAttachment
        v-if="currentStep === 5"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f5_formKey"
      ></BFormAttachment>
      <BFormSummary
        v-if="currentStep === 6"
        :masterData="masterData"
        :is-same-id="isSameId()"
        :key="f6_formKey"
      ></BFormSummary>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between to-hide">
      <Button theme="2" @onClick="onCancel">ยกเลิก</Button>

      <div class="flex-center" v-if="!$route.query.preview">
        <Button
          v-if="currentStep !== 1"
          theme="3"
          min-width="120px"
          :disabled="isLoading"
          @onClick="backForm"
        >
          &lt; ย้อนกลับ
        </Button>

        <Button
          theme="4"
          min-width="120px"
          :disabled="isLoading"
          @onClick="saveDraft"
          >บันทึกฉบับร่าง</Button
        >
        <Button
          theme="3"
          min-width="120px"
          :disabled="isLoading || doNotSubmit"
          @onClick="nextForm"
        >
          {{ currentStep === 6 ? "ยื่นโครงการ" : "ถัดไป >" }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep";
import Button from "../../components/input/Button";
import {
  eventBus,
  toDateFormat,
  toDateRangeFormat,
  validateEmail,
} from "../../plugins/global-funcs";
import BFormGeneral from "./B/BFormGeneral";
import BFormProject from "./B/BFormProject";
import BFormPlan from "./B/BFormPlan";
import BFormOOI from "./B/BFormOOI";
import BFormAttachment from "./B/BFormAttachment";
import BFormSummary from "./B/BFormSummary";
import { mapState } from "vuex";

export default {
  name: "FormB",
  components: {
    StatusStep,
    Button,
    BFormGeneral,
    BFormProject,
    BFormPlan,
    BFormOOI,
    BFormAttachment,
    BFormSummary,
  },
  data() {
    return {
      toDateRangeFormat,
      toDateFormat,
      currentStep: 1,
      doNotSubmit: false,
      documentSteps: [
        {
          no: 1,
          name: "ข้อมูลทั่วไป",
        },
        {
          no: 2,
          name: "ข้อมูลโครงการ",
        },
        {
          no: 3,
          name: "แผนการดำเนินงานวิจัย",
        },
        {
          no: 4,
          name: "OOI",
        },
        {
          no: 5,
          name: "เอกสารแนบ",
        },
      ],
      formGeneral: {},
      formProject: {},
      formPlan: {},
      formOOI: {},
      formAttachment: {},
      masterData: {},
      updateId: undefined,
      f1_formKey: 0,
      f2_formKey: 0,
      f3_formKey: 0,
      f4_formKey: 0,
      f5_formKey: 0,
      f6_formKey: 0,
      plan_code: "",
    };
  },
  async created() {
    if (
      !this.$route.query.plan_id &&
      !this.$route.query.form_a_id &&
      !this.$route.query.id
    )
      return this.onCancel();
    await this.getMasterData();
    if (this.$route.query.preview) return this.summaryForm();
    this.retrieveForms();

    //for dev
    // this.currentStep = 3
  },
  beforeDestroy() {
    eventBus.$off("bFormGeneralSend");
    eventBus.$off("bFormGeneral");
    eventBus.$off("bFormProjectSend");
    eventBus.$off("bFormProject");
    eventBus.$off("bFormPlanSend");
    eventBus.$off("bFormPlan");
    eventBus.$off("bFormPlanSetData");
    eventBus.$off("bFormOOISend");
    eventBus.$off("bFormOOI");
    eventBus.$off("bFormOOISetData");
    eventBus.$off("bFormAttachmentSend");
    eventBus.$off("bFormAttachment");
    eventBus.$off("bFormAttachmentSetData");
    eventBus.$off("bFormAbleToSubmit");
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
      userInfo: (state) => state.Auth.User,
      bFormId: (state) => state.BForm.id,
    }),
  },
  methods: {
    jumpStep(step) {
      if (step == this.currentStep) return;
      if (this.isLoading) {
        this.$store.commit("General/setModal", {
          title: "Wait a moment.",
          text: "Preparing data please wait...",
          theme: "warning",
          showCancel: false,
          buttonText: "OK",
        });
        return;
      }
      if (this.$route.query.id || this.updateId) {
        this.currentStep = parseInt(step);
        this.$vuetify.goTo("#app");
        this.doNotSubmit = false;
      } else {
        this.$store.commit("General/setModal", {
          title: "Complete this step first!",
          text: "Complete the first step then you can jump",
          theme: "error",
          showCancel: false,
          buttonText: "OK",
        });
      }
    },
    isSameId() {
      return !!this.$route.query.id && this.$route.query.id == this.bFormId;
    },
    backForm() {
      if (this.currentStep <= 1) return;
      // don't save when back from summary page
      if (this.currentStep <= this.documentSteps.length) {
        this.saveDraft();
      }
      this.currentStep -= 1;
      this.doNotSubmit = false;
      this.$vuetify.goTo("#app");
    },
    async nextForm() {
      if (this.currentStep > this.documentSteps.length) {
        await this.saveDraft(true);
        return this.$router.push({ name: "MainProjectOffer" });
      }
      let error = await this.saveDraft();
      if (error) return;
      this.currentStep += 1;
      this.$vuetify.goTo("#app");
    },
    async saveDraft(isSubmit = false) {
      // this.requestForm(this.currentStep)
      this.requestForm("all");

      // validate formGeneral
      // if (this.currentStep == 1) {
      //   if (
      //     this.formGeneral.pm_mobile_phone ||
      //     (this.formGeneral.pm_email &&
      //       !validateEmail(this.formGeneral.pm_email)) ||
      //     this.formGeneral.pc_mobile_phone ||
      //     (this.formGeneral.pc_email &&
      //       !validateEmail(this.formGeneral.pc_email))
      //   ) {
      //     this.$store.commit("General/setModal", {
      //       title: "ข้อมูลไม่ถูกต้อง",
      //       text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //       theme: "error",
      //       showCancel: false,
      //       buttonText: "OK",
      //     });
      //     return true;
      //   }
      // }

      let payload = {
        budget_amount: this.formPlan.budget_amount,
        form_ab_general_info: {
          ...this.formGeneral,
          kpi_quantity: this.formOOI.quantity,
          kpi_quality: this.formOOI.quality,
        },
        form_ab_project_info: this.formProject,
        project_section_plan: {
          ...this.formPlan,
          form_ab_budget: undefined,
        },
        form_ab_budget: this.formPlan.form_ab_budget,
        operating_activities: this.formPlan.operating_activities,
        kpi_annex_projects: this.formOOI.kpi_annex_projects,
        kpi_values: this.formOOI.kpi_values,
        attachments: this.formAttachment ? this.formAttachment : [],
      };

      console.log("form b payload", payload);

      if (this.$route.query.plan_id)
        payload.plan_id = this.$route.query.plan_id;
      if (this.$route.query.form_a_id)
        payload.form_a_id = this.$route.query.form_a_id;
      if (this.$route.query.inception_id)
        payload.inception_id = this.masterData.form_b.id;

      //check each this.formAttachment has a File or not
      if (payload.attachments?.length > 0) {
        let uploadPromises = payload.attachments.map((attachment, index) => {
          if (attachment instanceof File) {
            return this.uploadFile(attachment).then((result) => {
              console.log("file ", index, "is uploaded");
              return result;
            });
          } else {
            return Promise.resolve(attachment);
          }
        });
        payload.attachments = await Promise.all(uploadPromises);
      }

      let res;
      if (this.$route.query.id || this.updateId) {
        // case: update
        payload = {
          id: this.$route.query.id || this.updateId,
          payload: {
            ...payload,
            id: undefined,
            status: isSubmit ? "Submitted" : "Draft",
          },
        };

        console.log("payload updated: ", payload);
        res = await this.$apiFire("BForm/updateFormB", payload);
        if (res && res.id) {
          // success
          this.masterData.form_b = res;
          this.masterData.plan_master = res.plan_master;
          this.updateFormData(this.currentStep);
          // update component with changing key
          this.f1_formKey += 1;
          this.f2_formKey += 1;
          this.f3_formKey += 1;
          this.f4_formKey += 1;
          this.f5_formKey += 1;
          this.f6_formKey += 1;
        } else {
          // error validate
          return true;
        }
      } else {
        // case: store new
        payload.status = isSubmit ? "Submitted" : "Draft";
        console.log("payload store: ", payload);
        res = await this.$apiFire("BForm/storeFormB", payload);

        if (res) {
          this.updateId = res;
          this.$store.commit("BForm/setGeneralForm", this.formGeneral);
          window.history.replaceState(
            {},
            null,
            window.location.href + "&id=" + res
          );
        }
        // update changed data
        this.getMasterData();
      }
    },
    updateFormData(formStep) {
      switch (formStep) {
        case 3:
          eventBus.$emit("bFormPlanSetData");
          eventBus.$emit("bFormPlan");
          break;

        case 4:
          eventBus.$emit("bFormOOISetData");
          eventBus.$emit("bFormOOI");
          break;

        case 5:
          eventBus.$emit("bFormAttachmentSetData");
          eventBus.$emit("bFormAttachment");
          break;
      }
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("bFormGeneral");
          break;

        case 2:
          eventBus.$emit("bFormProject");
          break;

        case 3:
          eventBus.$emit("bFormPlan");
          break;

        case 4:
          eventBus.$emit("bFormOOI");
          break;

        case 5:
          eventBus.$emit("bFormAttachment");
          break;

        default:
          eventBus.$emit("bFormGeneral");
          eventBus.$emit("bFormProject");
          eventBus.$emit("bFormPlan");
          eventBus.$emit("bFormOOI");
          eventBus.$emit("bFormAttachment");
          break;
      }
    },
    retrieveForms() {
      // General form
      eventBus.$on("bFormGeneralSend", (form) => {
        this.formGeneral = form;
        // keep in storage
        this.$store.commit("BForm/setGeneralForm", this.formGeneral);
      });

      // Project form
      eventBus.$on("bFormProjectSend", (form) => {
        this.formProject = form;
        // keep in storage
        this.$store.commit("BForm/setProjectForm", this.formProject);
      });

      // Plan form
      eventBus.$on("bFormPlanSend", (form) => {
        this.formPlan = form;
        // keep in storage
        this.$store.commit("BForm/setPlanForm", this.formPlan);
      });

      // OOI form
      eventBus.$on("bFormOOISend", (form) => {
        this.formOOI = form;
        // keep in storage
        this.$store.commit("BForm/setOOIForm", this.formOOI);
      });

      // Attachment form
      eventBus.$on("bFormAttachmentSend", (form) => {
        this.formAttachment = form;
        // keep in storage
        this.$store.commit("BForm/setAttachmentForm", this.formAttachment);
      });

      // Allow to submit for the summary page
      eventBus.$on("bFormAbleToSubmit", (bool) => {
        this.doNotSubmit = !bool;
      });
    },
    async getMasterData() {
      let res;
      if (this.$route.query.id || this.updateId) {
        // edit (wait for api)
        let id = this.$route.query.id || this.updateId;
        res = await this.$apiFire("BForm/getEditMasterFormB", id);
        // update component with changing key
        this.f1_formKey += 1;
        this.f2_formKey += 1;
        this.f3_formKey += 1;
        this.f4_formKey += 1;
        this.f5_formKey += 1;
        this.f6_formKey += 1;
      } else {
        // create
        res = await this.$apiFire(
          "BForm/getMasterFormB",
          this.$route.query.plan_id
        );
        this.f1_formKey += 1;
      }
      // }

      console.log(res);
      if (res) {
        this.masterData = res;
        this.plan_code = this.masterData.plan_master[0].plan_code;

        let payload = {
          budget_amount: this.formPlan.budget_amount,
          form_ab_general_info: {
            ...this.formGeneral,
            kpi_quantity: this.formOOI.quantity,
            kpi_quality: this.formOOI.quality,
          },
          form_ab_project_info: this.formProject,
          project_section_plan: {
            ...this.formPlan,
            form_ab_budget: undefined,
          },
          form_ab_budget: this.formPlan.form_ab_budget,
          operating_activities: this.formPlan.operating_activities,
          kpi_annex_projects: this.formOOI.kpi_annex_projects,
          kpi_values: this.formOOI.kpi_values,
          attachments: this.formAttachment ? this.formAttachment : [],
        };

        // set data to form for next save
        this.formGeneral = res.form_b?.form_ab_general_info || {};
        this.formProject = res.form_b?.form_ab_project_info || {};
        this.formPlan = res.form_b?.project_section_plan || {};
        this.formPlan.budget_amount = res.form_b?.budget_amount;
        this.formPlan.form_ab_budget = res.form_b?.form_ab_budget || [];
        this.formPlan.operating_activities =
          res.form_b?.operating_activities || [];
        this.formOOI.kpi_annex_projects = res.form_b?.kpi_annex_projects || [];
        this.formOOI.kpi_values = res.form_b?.kpi_values || [];
        this.formOOI.kpi_quantity =
          res.form_b?.form_ab_general_info.kpi_quantity;
        this.formOOI.kpi_quality = res.form_b?.form_ab_general_info.kpi_quality;
        this.formAttachment = res.form_b?.attachments || [];
      } else {
        this.onCancel();
      }
    },
    onCancel() {
      if (this.$route.query.redirect) {
        this.$router.push({ name: this.$route.query.redirect });
      } else {
        // back route
        let backRoute = "MainProjectOffer";
        switch (this.userRole) {
          case "RSP":
            if (this.isFinal) {
              // RSP P/F
              backRoute = "ProgressReportOfferList";
            } else {
              // RSP S/I
              backRoute = "MainProjectOffer";
            }
            break;

          case "สป.อว.":
            if (this.isFinal) {
              // OIC P/F
              backRoute = "ReportFromRSPList";
            } else {
              // OIC S/I
              backRoute = "ProjectOfferFromRSP";
            }
            break;

          case "ผู้เชี่ยวชาญ":
            backRoute = "EvaluateList";
            break;
        }
        this.$router.push({ name: backRoute });
      }
    },
    async uploadFile(file) {
      let formData = new FormData();
      formData.append("files[]", file);
      let payload = {
        files: formData,
      };
      let res = await this.$apiFire("Attachment/uploadFile", formData);
      console.log("res@uploadFile", res);
      if (res.length > 0) {
        console.log("file uploaded", res[0]);
        return res[0];
      }
    },
    summaryForm() {
      this.currentStep = 6;
      this.$vuetify.goTo("#app");
    },
    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

      //change document title
      document.title =
        "Form_B_" +
        this.userInfo.user_type +
        "_" +
        this.plan_code +
        "_" +
        today;
      let toHide = document.getElementsByClassName("to-hide");
      let pdfPage = document.getElementById("pdf");
      let mainContent = document.getElementById("main");
      let titled = document.getElementsByClassName("titled");
      let toShow = document.getElementsByClassName("to-show");
      let noBoxShadow = document.getElementsByClassName("no-box-shadow");
      let s3p1 = document.getElementsByClassName("s3-p1");
      let s3p1h = document.getElementsByClassName("s3-p1-h");
      let indent_info = document.getElementsByClassName("indent-info");

      //remove all class name indent-info
      for (let i = 0; i < indent_info.length; i++) {
        indent_info[i].style.paddingLeft = "10px";
      }

      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      for (let i = 0; i < titled.length; i++) {
        titled[i].style.boxShadow = "none";

        //set box shadow to every child of titled
        let titledChild = titled[i].children;
        for (let j = 0; j < titledChild.length; j++) {
          titledChild[j].style.boxShadow = "none";
        }
      }

      //set no-box-shadow box-shadow to none
      for (let i = 0; i < noBoxShadow.length; i++) {
        noBoxShadow[i].style.boxShadow = "none";

        //set border
        noBoxShadow[i].style.border = "1px solid #F5F5F5";
      }

      //set s3p1 style scale 0.8
      for (let i = 0; i < s3p1.length; i++) {
        s3p1[i].style.transform = "scale(0.75)";
        s3p1[i].style.transformOrigin = "top left";
        s3p1[i].style.alignItems = "flex-start";

        //remove class overflow-x-auto
        s3p1[i].classList.remove("overflow-x-auto");
      }
      //set s3p1h style height
      for (let i = 0; i < s3p1h.length; i++) {
        s3p1h[i].style.height = "auto";
      }

      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },
    docTypeName() {
      if (
        this.masterData.form_b?.doc_type === "Progress" &&
        this.masterData.form_b?.progress_month > 0
      ) {
        return (
          "รายงานความก้าวหน้า " +
          this.masterData.form_b.progress_month.toString() +
          " เดือน"
        );
      } else if (this.masterData.form_b?.doc_type === "Final") {
        return "รายงานฉบับสมบูรณ์";
      }
      return "";
    },
    updateSubFormComponent() {
      this.f1_formKey += 1;
      this.f2_formKey += 1;
      this.f3_formKey += 1;
      this.f4_formKey += 1;
      this.f5_formKey += 1;
      this.f6_formKey += 1;
    },
    autoField(step, plan_code) {
      switch (step) {
        case 1:
          Object.assign(this.masterData.form_b.form_ab_general_info, {
            sci_park: "อุทยานวิทยาศาสตร์ประเทศไทย",
          });
          break;
        case 2:
          Object.assign(this.masterData.form_b.form_ab_project_info, {
            principle: "ตัวอย่างหลักการและเหตุผล",
            objective: "ตัวอย่างวัตถุประสงค์",
            industry_group: "ตัวอย่างกลุ่มอุตสาหกรรมเป้าหมาย",
            target: "ตัวอย่างเป้าหมายโครงการ",
            officer_potential: "ศักยภาพและความพร้อมของเจ้าหน้าที่",
            knowledge: "องค์ความรู้ที่ใช้สนับสนุนผู้ประกอบการ",
            expert: "การเชื่อมโยงผู้เชี่ยวชาญและเครือข่ายภายนอก",
            tech_service_model: "รูปแบบการให้บริการทางเทคโนโลยี",
            progress: "ขั้นตอนและขอบเขตการดำเนินโครงการ",
            overview: "ผลการดำเนินงานที่ผ่านมา",
            impr_direction: "แนวทางการปรับปรุงจากผลการดำเนินงาน",
            future_service: "แนวความคิด (new initiative) ในอนาคต",
          });
          break;
        case 3:
          this.masterData.form_b.project_section_plan.project_plan_p1 = [
            {
              p1_activity_name: "ทดสอบ การศึกษาและวิเคราะห์",
              p1_wf: "0.50",
              project_section_plan_month: [
                {
                  year_month: "2024-10",
                  month_value: "30.00",
                  actual_month_value: "25.00",
                },
                {
                  year_month: "2024-11",
                  month_value: "60.00",
                  actual_month_value: "55.00",
                },
                {
                  year_month: "2024-12",
                  month_value: "100.00",
                  actual_month_value: "90.00",
                },
                ...Array(9)
                  .fill()
                  .map((_, i) => ({
                    year_month: `2025-${String(i + 1).padStart(2, "0")}`,
                    month_value: null,
                    actual_month_value: null,
                  })),
              ],
            },
            {
              p1_activity_name: "ทดสอบ การพัฒนาต้นแบบ",
              p1_wf: "0.50",
              project_section_plan_month: [
                {
                  year_month: "2024-10",
                  month_value: null,
                  actual_month_value: null,
                },
                {
                  year_month: "2024-11",
                  month_value: "40.00",
                  actual_month_value: "35.00",
                },
                {
                  year_month: "2024-12",
                  month_value: "100.00",
                  actual_month_value: "85.00",
                },
                ...Array(9)
                  .fill()
                  .map((_, i) => ({
                    year_month: `2025-${String(i + 1).padStart(2, "0")}`,
                    month_value: null,
                    actual_month_value: null,
                  })),
              ],
            },
          ];

          break;
        case 4:
          // กำหนดค่า kpi_quantity และ kpi_quality
          Object.assign(this.masterData.form_b.form_ab_general_info, {
            kpi_quantity: "เพิ่มยอดขาย 20%",
            kpi_quality: "พัฒนาคุณภาพสินค้าสอดคล้องตามมาตรฐานสากล",
          });

          // กำหนด Annex Projects (โครงการภาคผนวก)
          this.masterData.form_b.kpi_annex_project = [
            { form_c_id: 1 },
            { form_c_id: 2 },
          ];

          // สมมติว่า plan_master มีข้อมูลแล้ว
          if (this.masterData.plan_master) {
            this.masterData.plan_master.forEach((plan) => {
              plan.kpi_masters.forEach((kpi, index) => {
                kpi.kpi_values = {
                  id: index + 1,
                  kpi_master_id: kpi.id,
                  kpi_value: (index + 1) * 10, // ตัวอย่างค่าเป้า RSP
                  kpi_value_ops: (index + 1) * 8, // ตัวอย่างค่าเป้า สป.อว.
                  description: "รายละเอียด KPI " + (index + 1),
                };
              });
            });
          }
          break;
      }

      this.updateSubFormComponent();
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="scss">
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
